import { Button, ButtonProps } from "@mui/material";
import { MenuBook as MenuBookIcon } from "@mui/icons-material";
import styled from "styled-components";

interface Props extends ButtonProps {
  docsPath: string;
}

export function ButtonDocs(props: Props) {
  return (
    <StyledButton
      href={`${window._env_.REACT_APP_DOCS_URL}/${props.docsPath}`}
      variant="outlined"
      endIcon={<MenuBookIcon />}
      color="inherit"
    >
      {props.children}
    </StyledButton>
  );
}
export const StyledButton = styled(Button).attrs({
  target: "_blank",
})`
  background-color: white;
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  color: ${({ theme }) => theme.palette.grey[700]};

  .MuiSvgIcon-root {
    transform: translateY(-1px);
  }
`;
